import React from 'react';
import {MasterLayout} from 'components/layouts';
import {AnnouncementContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class Announcement extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.Announcement;
  }

  render() {
    return (
      <MasterLayout>
        <AnnouncementContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(Announcement);



// WEBPACK FOOTER //
// ./pages/users/Announcement.jsx